(() => {
  const dialog = document.getElementById('treuespur-garantie');
  if (!(dialog instanceof HTMLDialogElement)) return;
  let opener;
  const open = (trigger) => {
    if (dialog.open) return;
    opener = trigger;
    dialog.showModal();
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.hash !== '#treuespur-garantie') return;
    event.preventDefault();
    open(link);
  });
  dialog.querySelector('[data-ts-guarantee-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { if (opener instanceof HTMLElement && opener.isConnected) opener.focus(); });
  const openFromHash = () => { if (location.hash === '#treuespur-garantie') open(); };
  window.addEventListener('hashchange', openFromHash);
  openFromHash();
})();
